import React, { useRef, useState } from 'react';
import { Upload, ImageIcon } from 'lucide-react';

export const ImageUploader = ({ value, onChange, onUpload, resolveImg, t }) => {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const handleFile = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      await onUpload(file);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="md:w-56 w-full flex-shrink-0">
      <div className="aspect-square w-full rounded-xl border-[1.5px] border-dashed border-black/30 overflow-hidden bg-black/[0.03] flex items-center justify-center">
        {value ? (
          <img src={resolveImg(value)} alt="preview" className="w-full h-full object-cover" />
        ) : (
          <div className="text-center text-black/40">
            <ImageIcon className="mx-auto mb-1" size={22} />
            <span className="text-xs font-bold">Nessuna foto</span>
          </div>
        )}
      </div>
      <div className="mt-2 space-y-2">
        <input
          ref={inputRef}
          type="file"
          accept="image/*"
          capture="environment"
          className="hidden"
          onChange={(e) => handleFile(e.target.files?.[0])}
        />
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          disabled={busy}
          className="w-full pill-btn text-xs py-1.5 primary"
        >
          <Upload size={12} /> {busy ? 'Caricamento...' : 'Carica foto'}
        </button>
        <input
          type="text"
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          placeholder="...oppure incolla URL"
          className="w-full rounded-full border-[1.5px] border-black/20 bg-white px-3 py-1.5 focus:outline-none focus:border-black text-xs"
        />
        {value && (
          <button
            type="button"
            onClick={() => onChange('')}
            className="w-full text-xs text-black/50 hover:text-red-700 font-bold"
          >Rimuovi</button>
        )}
      </div>
    </div>
  );
};

export default ImageUploader;
